document.addEventListener('DOMContentLoaded', function () {
    // --- Gestion de l'offcanvas pour mobile ---
    var offcanvasEl = document.getElementById('offcanvasNavbar');
    var mainContent = document.querySelector('.dialog-off-canvas-main-canvas[data-off-canvas-main-canvas]');
  
    if (offcanvasEl && mainContent) {
      offcanvasEl.addEventListener('shown.bs.offcanvas', function () {
        mainContent.classList.add('shift-left');
      });
      offcanvasEl.addEventListener('hidden.bs.offcanvas', function () {
        mainContent.classList.remove('shift-left');
      });
    }
  
    // --- Gestion du sous-menu au survol en desktop ---
    if (window.innerWidth >= 992) { // Appliquer pour les écrans larges
      var dropdowns = document.querySelectorAll('.dropdown');
      dropdowns.forEach(function (dropdown) {
        dropdown.addEventListener('mouseenter', function () {
          // Ajoute la classe 'show' au parent et à son sous-menu
          this.classList.add('show');
          var dropdownMenu = this.querySelector('.dropdown-menu');
          if (dropdownMenu) {
            dropdownMenu.classList.add('show');
          }
        });
        dropdown.addEventListener('mouseleave', function () {
          // Retire la classe 'show' au parent et à son sous-menu
          this.classList.remove('show');
          var dropdownMenu = this.querySelector('.dropdown-menu');
          if (dropdownMenu) {
            dropdownMenu.classList.remove('show');
          }
        });
      });
    }
  });
  